const MSG_ERRO_SERVIDOR = "Ocorreu um erro na sua requisição. Tente novamente mais tarde.";
const MSG_ERRO_ACESSO_RECURSO = "Necessário perfil adequado para solicitar este recurso.";

/**
 * A partir de response de erro no request (exemplo: HTTP 400 Bad Request) obter mensagem recebida do MensagemTO retornado do SAG.
 * Caso não encontre a mensagem dentro do MensagemTO, retorna o erro padrão do servidor.
 * Exemplo: Response com body {"mensagem": "Dados incompatíveis com usuário"} retornaria "Dados incompatíveis com usuário"
 * @param {*} erro - erro contendo response considerada de erro obtida dos métodos do requests.js
 */
export function obterMensagemErroResponse(erro) {
  return erro &&
    erro.response &&
    erro.response.data &&
    erro.response.data.mensagem
    ? erro.response.data.mensagem
    : obterMensagensErroResponse(erro);
}

export function obterMensagensErroResponse(erro) {
  return erro &&
    erro.response &&
    erro.response.data &&
    erro.response.data.mensagens &&
    erro.response.data.mensagens.length > 0
    ? erro.response.data.mensagens[0].erro //retorna a primeira mensagem de erro
    : obterMensagemParaRecursoNegadoOuErroGeral(erro);
}

/**
 * Verifica se foi um erro 401 retornado pelo newdoo (o da API teria sido retornado em data.mensagem)
 * @param {*} erro - com o response do erro (request.js / axios)
 */
const obterMensagemParaRecursoNegadoOuErroGeral = erro => {
  if (
    erro &&
    erro.response &&
    erro.response.data &&
    erro.response.data.message
  ) {
    return erro.response.data.message;
  } else {
    return erro &&
      erro.response &&
      erro.response.status &&
      erro.response.status === 401
      ? MSG_ERRO_ACESSO_RECURSO
      : MSG_ERRO_SERVIDOR;
  }
};
/**
 * A partir de response no request obter mensagem recebida do MensagemTO retornado do SAG.
 * Caso não encontre a mensagem dentro do MensagemTO, retorna string vazia.
 * Exemplo: Response com body {"mensagem": "Remoção de procurador realizada com sucesso"} retornaria "Remoção de procurador realizada com sucesso"
 * @param {*} resposta - resposta contendo response obtida dos métodos do requests.js
 */
export function obterMensagemResponse(resposta) {
  return resposta && resposta.mensagem ? resposta.mensagem : '';
}

export function montarMensagemErro(mensagem) {
  return {
    response: {
      data: {
        mensagem: mensagem
      }
    }
  };
}

export function obterMensagensDeAlertaDoResponse(erro) {
  return erro &&
    erro.response &&
    erro.response.data &&
    erro.response.data.avisos
    ? erro.response.data.avisos
    : [];
}
